module.exports = __webpack_public_path__ + "static/media/AnHM8TFIs0M.a2378c7a.jpg";